export const productsTableHeader = [
  {columnKey: 'productName', header: 'Product Name', columnFilterPlaceholder: 'Product Name'},
  {columnKey: 'productId', header: 'Product ID', columnFilterPlaceholder: 'Product ID'},
  {columnKey: 'gtin', header: 'GTIN', columnFilterPlaceholder: 'GTIN'},
  {columnKey: 'category', header: 'Category', columnFilterPlaceholder: 'Category'},
  {columnKey: 'brand', header: 'Brand', columnFilterPlaceholder: 'Brand'},
]

export const gtinTableColumns = [
  {columnKey: 'productName', header: 'Product Name', columnFilterPlaceholder: 'Product Name'},
  {columnKey: 'productId', header: 'Product ID', columnFilterPlaceholder: 'Product ID'},
]

export const GTINDetailsListColConfig = [
  {
    name_of_db_column: 'productName',
    label_of_column: 'Product Name',
    order_of_column: 1,
  },
  {
    name_of_db_column: 'productId',
    label_of_column: 'Product ID',
    order_of_column: 2,
  },
]
